import Repository from "./Repository";

const resource = "/stores";

export default {
	index() {
		return Repository.get(resource);
	}
}